module.exports = __webpack_public_path__ + "img/0080.84bf97c4.jpg";